import React, { useState, useEffect, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { setLoading, setSnackInfo } from '../../../redux/actions/appAction'
import HttpService from '../../../services/httpService'
import { connect } from 'react-redux'
import { makeStyles, useTheme, withStyles } from '@material-ui/core/styles';
import { Paper, Button, Table, TableHead, TableBody, TableRow, TableCell, TableContainer, TableFooter, TablePagination } from '@material-ui/core';
import { DownloadOutlined } from '@ant-design/icons';
import EditIcon from '@material-ui/icons/Edit';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { TextField } from '@material-ui/core';
import Slide from '@material-ui/core/Slide';
import FormControl from '@material-ui/core/FormControl';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Autocomplete from '@material-ui/lab/Autocomplete';
import GenerateSticker from '../../../components/generateSticker';
import ScannerIcon from '@material-ui/icons/Scanner';
import moment from 'moment';
import { ROLENAME } from '../../../utils/index';
import './index.css'
import { Link } from 'react-router-dom'

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
	root: { flexShrink: 0, marginLeft: theme.spacing(2.5) },
	heading: { margin: 'auto', textAlign: "center", marginBottom: '1%', color: "#FFF2EB", backgroundColor: "#1C375D", padding: 10, borderRadius: 50, width: "30%" },
	table: { minWidth: 500 },
	textField: { width: "150px" },
	excelDownloadButton: { backgroundColor: '#19571b', margin: 5, height: '40px', width: "1px", borderRadius: 50, fontSize: '150%', "&:hover": { backgroundColor: "white", color: '#19571b' } },
	sawDownloadButton: { backgroundColor: '#141d5c', margin: 5, height: '40px', width: "1px", borderRadius: 50, fontSize: '150%', "&:hover": { backgroundColor: "white", color: '#141d5c' } },
	downloadButton: { backgroundColor: "#1C375D", color: "#FFF2EB" },
	uploadRedirectButton: {
		backgroundColor: "#1C375D",
		color: "#FFF2EB",
		float: "left",
		marginTop: 15,
		marginLeft: 10,
		marginBottom: 10,
		padding: "10px 18px",
		borderRadius: 50,
		fontWeight: 600,
		textTransform: "none",
		"&:hover": { backgroundColor: "#FFF2EB", color: "#1C375D" }
	}
}));

const OptimisationFiles = (props) => {
	const classes = useStyles();
	const [optimisationFiles, setOptimisationFiles] = useState([])
	const { userDetails } = useSelector(state => state.user)
	const [excelFileUpload, setExcelFIleUpload] = useState(false);
	const [patternFileUpload, setPatternFileUpload] = useState(false);
	const [searchField, setSearchField] = useState("")
	const [sawfileUpload, setSawFileUpload] = useState(false);
	const [sawfile2Upload, setSawFile2Upload] = useState(false);
	const [pastingFileUpload, setpastingFileUpload] = useState(false);
	const [pastingListBOMUpload, setPastingListBOMUpload] = useState(false);
	const [selectedProject, setSelectedProject] = useState([])
	const [approvedProjects, setApprovedProjects] = useState([]);
	const [selectedId, setSelectedId] = useState(null);
	const [forceTrigger, setForceTrigger] = useState(false);
	const [page, setPage] = useState(1);
	const [rowsPerPage] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [editOptimisationFile, setEditOptismisationFile] = useState({
		excelFileLink: "",
		sawFileLink: "",
		pastingFile: "",
		pastingListBOMFile: "",
		patternFileLink: "",
		sawFile2Link: "",
		optimizationNumber: "",
		projects: [],
		imosFile: "",
	})
	const [isEdit, setIsEdit] = useState(false)
	const [openModal, setOpenModal] = useState(false);
	const [imosFileUpload, setImosFileUpload] = useState(false);

	useEffect(() => {
		getOptimisationFiles(page)
		getApprovedProjects()
	}, [])

	const handleClick = useCallback((id) => {
		setSelectedId(id);
		setForceTrigger(prev => !prev);
	}, []);

	
	const getOptimisationFiles = async (pageNumber = 1, search = "") => {
		props.setLoading(true)
		try {
			let response = await HttpService.getOptimisationFilesNew(pageNumber, rowsPerPage, search)
			setOptimisationFiles(response.data.optimisationFiles)
			setTotalCount(response.data.totalCount)
		}
		catch (error) {
			console.error("error", error)
		}
		props.setLoading(false)
	}

	
	const handlePageChange = (event, newPage) => {
		const pageNumber = newPage + 1;
		setPage(pageNumber)
		getOptimisationFiles(pageNumber, searchField)  
	}

	const StyledTableRow = withStyles((theme) => ({
		root: { '&:nth-of-type(odd)': { backgroundColor: theme.palette.action.hover } }
	}))(TableRow);

	const StyledTableCell = withStyles((theme) => ({
		head: { backgroundColor: "#ccc", color: theme.palette.common.black },
		body: { fontSize: 14 }
	}))(TableCell);

	const editOptismisationFile = (data) => {
		setOpenModal(true)
		let totalPro = []
		let val = data.projectsIds
		for (let i = 0; i < val.length; i++) {
			totalPro.push({
				searchName: val[i].projectNumber + "_" + val[i].clientName,
				_id: val[i]._id,
			})
		}
		setSelectedProject(totalPro)
		setEditOptismisationFile({
			excelFileLink: data.excelFileLink,
			sawFileLink: data.sawFileLink,
			pastingFile: data.pastingFile,
			pastingListBOMFile: data.pastingListBOMFile,
			patternFileLink: data.patternFileLink,
			optimizationNumber: data?.optimizationNumber,
			sawFile2Link: data.sawFile2Link,
			imosFile: data.imosFile,
			_id: data._id
		})
	}

	const onImageChange = async (e) => {
		const { name, value } = e.target
		props.setLoading(true)
		const fd = new FormData()
		fd.append('file', e.target.files[0])
		fd.append('customerName', "floor" + '_' + "plan")
		try {
			const fileUploadRes = await HttpService.uploadFile(fd);
			setEditOptismisationFile({
				...editOptimisationFile,
				[name]: fileUploadRes.data
			})
			if ([name][0] === "excelFileLink") {
				setExcelFIleUpload(true);
			} else if ([name][0] === "sawFileLink") {
				setSawFileUpload(true)
			} else if ([name][0] === "sawFile2Link") {
				setSawFile2Upload(true)
			} else if ([name][0] === 'pastingFile') {
				setpastingFileUpload(true)
			} else if ([name][0] === 'patternFileLink') {
				setPatternFileUpload(true)
			} else if ([name][0] === 'pastingListBOMFile') {
				setPastingListBOMUpload(true)
			} else if ([name][0] === 'imosFile') {
				setImosFileUpload(true)
			}
		} catch (err) {
			props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error")
		}
		props.setLoading(false)
	}

	const getApprovedProjects = async () => {
		try {
			props.setLoading(true)
			const response = await HttpService.getApprovedProjects()
			setApprovedProjects(response.data)
			props.setLoading(false)
		} catch (error) {
			props.setLoading(false)
			props.setSnackInfo(error.response.data.message, "error")
		}
	}

	const handleAddProject = async (event, value) => {
		setSelectedProject(value)
	}

	const UpdateData = async () => {
		let arr = []
		for (let i = 0; i < selectedProject.length; i++) {
			arr.push(selectedProject[i]._id)
		}
		let obj = {
			...editOptimisationFile,
			projects: arr,
			uploadedBy: userDetails._id,
		}
		props.setLoading(true)
		try {
			let response = await HttpService.updateOptimizedSingleFile(obj._id, obj)
			props.setSnackInfo("Updated Successfully", "success")
			setOpenModal(false)
			setpastingFileUpload(false)
			setPage(1)                 
			getOptimisationFiles(1)    
			setSearchField("") 
		}
		catch (error) {
			props.setSnackInfo(error.response.data.message, "error")
		}
		props.setLoading(false)
	}

	
	const searchProject = (e) => {
		const value = e.target.value
		setSearchField(value)
		setPage(1)
		getOptimisationFiles(1, value)  
	}

	return (
		<div>
			{selectedId && <GenerateSticker id={selectedId} forceTrigger={forceTrigger} />}

			<Link to="/optimisation_files/upload" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
				<Button
					className={classes.uploadRedirectButton}
					variant="contained"
					startIcon={<CloudUploadIcon />}
				>
					Upload Optimisation Files
				</Button>
			</Link>

			<TextField
				label="Search Project"
				type="text"
				value={searchField}
				style={{ marginBottom: 10, marginTop: 15, marginRight: 10, float: "right" }}
				name="searchField"
				onChange={searchProject}
				variant="outlined"
			/>

			<h1 className={classes.heading}>All Optimisation Files</h1>
			<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
				<TablePagination
					rowsPerPageOptions={[10]}
					component="div"
					count={totalCount}
					rowsPerPage={rowsPerPage}
					page={page - 1}
					onPageChange={handlePageChange}
					onRowsPerPageChange={(event) => {
						setPage(1)
						getOptimisationFiles(1, searchField)
					}}
				/>
				<div style={{ display: 'flex', alignItems: 'center', gap: 6, marginLeft: 16, whiteSpace: 'nowrap' }}>
					<span style={{ fontSize: 14 }}>Go to page:</span>
					<input
						type="number"
						min={1}
						max={Math.ceil(totalCount / rowsPerPage)}
						defaultValue={page}
						key={page}
						onBlur={(e) => {
							const enteredPage = parseInt(e.target.value)
							const totalPages = Math.ceil(totalCount / rowsPerPage)
							if (enteredPage >= 1 && enteredPage <= totalPages) {
								setPage(enteredPage)
								getOptimisationFiles(enteredPage, searchField)
							} else {
								e.target.value = page
							}
						}}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								const enteredPage = parseInt(e.target.value)
								const totalPages = Math.ceil(totalCount / rowsPerPage)
								if (enteredPage >= 1 && enteredPage <= totalPages) {
									setPage(enteredPage)
									getOptimisationFiles(enteredPage, searchField)
								} else {
									e.target.value = page
								}
							}
						}}
						style={{
							width: 55,
							padding: '4px 8px',
							border: '1px solid #1C375D',
							borderRadius: 4,
							fontSize: 14,
							textAlign: 'center'
						}}
					/>
					<span style={{ fontSize: 14 }}>of {Math.ceil(totalCount / rowsPerPage)}</span>
				</div>
			</div>

			<TableContainer component={Paper}>
				<Table className={classes.table} size="small" aria-label="custom pagination table">
					<TableHead>
						<TableRow>
							<StyledTableCell style={{ textAlign: 'center' }}>S.No.</StyledTableCell>
							<StyledTableCell style={{ textAlign: 'center' }}>Optimization Number</StyledTableCell>
							<StyledTableCell style={{ textAlign: 'center' }}>Projects</StyledTableCell>
							<StyledTableCell style={{ textAlign: 'center' }}>Uploaded By</StyledTableCell>
							<StyledTableCell style={{ textAlign: 'center' }}>Updated At</StyledTableCell>
							<StyledTableCell style={{ textAlign: 'center' }}>Tracking Sheet</StyledTableCell>
							<StyledTableCell style={{ textAlign: 'center' }}>Patterns & Summaries</StyledTableCell>
							<StyledTableCell style={{ textAlign: 'center' }}>IMOS File</StyledTableCell>
							<StyledTableCell style={{ textAlign: 'center' }}>Saw File 1</StyledTableCell>
							<StyledTableCell style={{ textAlign: 'center' }}>Saw File 2</StyledTableCell>
							<StyledTableCell style={{ textAlign: 'center' }}>Pasting List</StyledTableCell>
							<StyledTableCell style={{ textAlign: 'center' }}>Pasting list BOM</StyledTableCell>
							{
								userDetails.roles.find(role => role.name !== ROLENAME.BOMManager && role.name !== ROLENAME.ProcurementExecutive) &&
								(
									<>
										<StyledTableCell style={{ textAlign: 'center' }}>Action</StyledTableCell>
										<StyledTableCell style={{ textAlign: 'center' }}>Generate Sticker</StyledTableCell>
									</>
								)
							}
						</TableRow>
					</TableHead>
					<TableBody>
						{/* ✅ No .slice() needed — backend returns only 10 records */}
						{optimisationFiles.map((data, i) => (
							<StyledTableRow key={data._id}>
								<StyledTableCell style={{ textAlign: 'center' }}>
									{(page - 1) * rowsPerPage + i + 1}  {/* ✅ Correct S.No. across pages */}
								</StyledTableCell>
								<StyledTableCell style={{ textAlign: 'center' }}>{data?.optimizationNumber}</StyledTableCell>
								<StyledTableCell>
									{data.projectsIds.map((el) =>
										<Link to={`/project-logs/${el?.leadId}`} style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>
											{el?.projectNumber + ","}
										</Link>
									)}
								</StyledTableCell>
								<StyledTableCell style={{ textAlign: 'center' }}>{data?.uploadedBy}</StyledTableCell>
								<StyledTableCell style={{ textAlign: 'center' }}>{moment(data?.updatedAt).format('DD-MM-YYYY')}</StyledTableCell>

								<StyledTableCell style={{ textAlign: 'center' }}>
									{data.excelFileLink && data.excelFileLink !== '' ?
										(<Button className={classes.downloadButton} variant="contained" shape="round" color="primary" onClick={() => window.open(data.excelFileLink)}><DownloadOutlined /></Button>) :
										"NA"
									}
								</StyledTableCell>

								<StyledTableCell style={{ textAlign: 'center' }}>
									{data.patternFileLink && data.patternFileLink !== '' ?
										(<Button className={classes.downloadButton} variant="contained" shape="round" color="primary" onClick={() => window.open(data.patternFileLink)}><DownloadOutlined /></Button>) :
										"NA"
									}
								</StyledTableCell>

								<StyledTableCell style={{ textAlign: 'center' }}>
									{data.imosFile && data.imosFile !== '' ?
										(<Button className={classes.downloadButton} variant="contained" shape="round" color="primary" onClick={() => window.open(data.imosFile)}><DownloadOutlined /></Button>) :
										"NA"
									}
								</StyledTableCell>

								<StyledTableCell style={{ textAlign: 'center' }}>
									{data.sawFileLink && data.sawFileLink !== '' ?
										(<Button className={classes.downloadButton} variant="contained" shape="round" color="primary" onClick={() => window.open(data.sawFileLink)}><DownloadOutlined /></Button>) :
										"NA"
									}
								</StyledTableCell>

								<StyledTableCell style={{ textAlign: 'center' }}>
									{data.sawFile2Link && data.sawFile2Link !== '' ?
										(<Button className={classes.downloadButton} variant="contained" shape="round" color="primary" onClick={() => window.open(data.sawFile2Link)}><DownloadOutlined /></Button>) :
										"NA"
									}
								</StyledTableCell>

								<StyledTableCell style={{ textAlign: 'center' }}>
									{data.pastingFile && data.pastingFile !== '' ?
										(<Button className={classes.downloadButton} variant="contained" shape="round" color="primary" onClick={() => window.open(data.pastingFile)}><DownloadOutlined /></Button>) :
										"NA"
									}
								</StyledTableCell>

								<StyledTableCell style={{ textAlign: 'center' }}>
									{data.pastingListBOMFile && data.pastingListBOMFile !== '' ?
										(<Button className={classes.downloadButton} variant="contained" shape="round" color="primary" onClick={() => window.open(data.pastingListBOMFile)}><DownloadOutlined /></Button>) :
										"NA"
									}
								</StyledTableCell>

								{userDetails.roles.find(role => role.name !== ROLENAME.BOMManager && role.name !== ROLENAME.ProcurementExecutive) && (
									<>
										<StyledTableCell style={{ textAlign: "center" }}>
											<EditIcon className='editbutton' style={{ color: "#1C375D" }} onClick={() => editOptismisationFile(data)} />
										</StyledTableCell>
										<StyledTableCell style={{ textAlign: 'center' }} onClick={() => handleClick(data?._id)}>
											<Button variant='outlined' style={{ border: "1px solid #1C375D" }} color='primary'>
												<ScannerIcon style={{ color: "#1C375D" }} />
											</Button>
										</StyledTableCell>
									</>
								)}
							</StyledTableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>

			<Dialog open={openModal} onClose={() => setOpenModal(false)} aria-labelledby="form-dialog-title" maxWidth='lg'>
				<DialogContent>
					<DialogContentText id="alert-dialog-slide-description" style={{ display: "flex", flexDirection: "column" }}>
						{
							userDetails.roles.find(role => role.name === ROLENAME.Admin || role.name === ROLENAME.IMOSManager || role.name === ROLENAME.IMOSUser) &&
							<>
								<FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
									<>
										<input accept=".xlsx, .xls, .csv" className={classes.input} id="contained-button-file" multiple type="file" onChange={onImageChange} style={{ display: 'none' }} name="excelFileLink" />
										<label htmlFor="contained-button-file">
											<Button variant="contained" color="primary" component="span" startIcon={<CloudUploadIcon />}>
												Upload Tracking Sheet
											</Button>
											{excelFileUpload && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />}
										</label>
									</>
								</FormControl>

								<FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
									<>
										<input accept=".pdf" className={classes.input} id="patternFile-button-file" multiple type="file" onChange={onImageChange} style={{ display: 'none' }} name="patternFileLink" />
										<label htmlFor="patternFile-button-file">
											<Button variant="contained" color="primary" component="span" startIcon={<CloudUploadIcon />}>
												Upload Patterns & Summaries
											</Button>
											{patternFileUpload && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />}
										</label>
									</>
								</FormControl>

								<FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
									<>
										<input accept=".saw" className={classes.input} id="contained-button-file1" multiple type="file" onChange={onImageChange} style={{ display: 'none' }} name="sawFileLink" />
										<label htmlFor="contained-button-file1">
											<Button variant="contained" color="primary" component="span" startIcon={<CloudUploadIcon />}>
												Upload Saw File 1
											</Button>
											{sawfileUpload && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />}
										</label>
									</>
								</FormControl>

								<FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 30, display: 'block' }}>
									<>
										<input accept=".saw" className={classes.input} id="contained-button-file14" multiple type="file" onChange={onImageChange} style={{ display: 'none', marginLeft: 10, marginRight: 10 }} name="sawFile2Link" />
										<label htmlFor="contained-button-file14">
											<Button variant="contained" color="primary" component="span" startIcon={<CloudUploadIcon />}>
												Upload Saw File 2
											</Button>
											{sawfile2Upload && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />}
										</label>
									</>
									{
										userDetails.roles.find(role => role.name === ROLENAME.Admin) &&
										<FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 30, display: 'block' }}>
											<>
												<input accept=".xlsx, .xls, .csv" className={classes.input} id="contained-button-file2" multiple type="file" onChange={onImageChange} style={{ display: 'none' }} name="pastingFile" />
												<label htmlFor="contained-button-file2">
													<Button variant="contained" color="primary" component="span" startIcon={<CloudUploadIcon />}>
														Upload Pasting List
													</Button>
													{pastingFileUpload && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />}
												</label>
											</>
										</FormControl>
									}
								</FormControl>

								<FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 30, display: 'block' }}>
									<>
										<input accept=".xlsx, .xls, .csv" className={classes.input} id="contained-button-file2-imos-file" multiple type="file" onChange={(e) => onImageChange(e)} style={{ display: 'none' }} name="imosFile" />
										<label htmlFor="contained-button-file2-imos-file">
											<Button variant="contained" color="primary" component="span" startIcon={<CloudUploadIcon />}>
												Patterns & Summaries Excel file
											</Button>
											{imosFileUpload && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />}
										</label>
									</>
								</FormControl>
							</>
						}

						{
							userDetails.roles.find(role => role.name === ROLENAME.FactoryBom || role.name === ROLENAME.FactoryManager) &&
							<>
								<FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 20, display: 'block' }}>
									<>
										<input accept=".xlsx, .xls, .csv" className={classes.input} id="contained-button-file18" multiple type="file" onChange={onImageChange} style={{ display: 'none' }} name="pastingFile" />
										<label htmlFor="contained-button-file18">
											<Button variant="contained" color="primary" component="span" startIcon={<CloudUploadIcon />}>
												Upload Pasting List
											</Button>
											{pastingFileUpload && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />}
										</label>
									</>
								</FormControl>

								<FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 5, marginBottom: 30, display: 'block' }}>
									<>
										<input accept=".xlsx, .xls, .csv" className={classes.input} id="pasting-contained-button-file1" multiple type="file" onChange={onImageChange} style={{ display: 'none' }} name="pastingListBOMFile" />
										<label htmlFor="pasting-contained-button-file1">
											<Button variant="contained" color="primary" component="span" startIcon={<CloudUploadIcon />}>
												Upload Pasting list BOM
											</Button>
											{pastingListBOMUpload && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />}
										</label>
									</>
								</FormControl>
							</>
						}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={UpdateData} color="primary">
						UPDATE
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}

export default connect(null, { setLoading, setSnackInfo })(OptimisationFiles)